import { NetworkError, fetchPublicAPI } from "hooks/usePublicAPI";
import type { SubmitAnswer } from "pages/StartLead/submit";

import type { CorrectionBody } from "./correction";

/** POSTs a correction of the destination typed on the lead form and reports
 * how the server answered. The browser's handoff cookie rides along with the
 * signed link's parameters. */
export async function postCorrection(
  submissionId: string,
  body: CorrectionBody,
): Promise<SubmitAnswer> {
  try {
    const response = await fetchPublicAPI<unknown>(
      `/leads/submissions/${encodeURIComponent(submissionId)}/corrections`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      },
    );
    return { status: 200, body: response };
  } catch (err) {
    if (err instanceof NetworkError) {
      return { status: err.statusCode, body: err.responseData };
    }
    return { status: null, body: undefined };
  }
}
